// MuteButton.jsx
import { useCallback } from 'react';
import PropTypes from 'prop-types';

import AudioOnIcon from '../../img/icon-audio-fill-shadow.svg';
import AudioOffIcon from '../../img/icon-mute-fill-shadow.svg';
import { NULL_FUNCTION } from '../resource/defaults.js';

export const MuteButton = ({
  isMuted = false,
  setMute = NULL_FUNCTION,
  children = NULL_FUNCTION,
}) => {
  const handleOnClick = useCallback(() => {
    setMute(!isMuted);
  }, [isMuted, setMute]);

  return children({
    isMuted,
    handleOnClick,
    iconSource: isMuted ? AudioOffIcon : AudioOnIcon,
  });
};

MuteButton.propTypes = {
  isMuted: PropTypes.bool,
  setMute: PropTypes.func,
  children: PropTypes.func,
};

export default MuteButton;
